import { render, staticRenderFns } from "./optionTemplate.vue?vue&type=template&id=3dea6ffa&scoped=true&"
import script from "./optionTemplate.vue?vue&type=script&lang=js&"
export * from "./optionTemplate.vue?vue&type=script&lang=js&"
import style0 from "./optionTemplate.vue?vue&type=style&index=0&id=3dea6ffa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dea6ffa",
  null
  
)

export default component.exports